import { render } from "./asegurado.vue?vue&type=template&id=e9d37f8a"
import script from "./asegurado.vue?vue&type=script&lang=js"
export * from "./asegurado.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__